import { useEffect, useState } from 'react';
import { api, apiSecure } from '../axios.service';
import { ConnexionRequest } from '../../types/request/connexion.model';
import { ResponseApi } from '../../types/response/responseapi.model';
import { TokenValid } from '../../types/request/tokenvalid.model'

export function useConnexion(request : ConnexionRequest | null | undefined){
        
    const [data, setData] = useState<ResponseApi>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        if (request) {
        setIsLoading(true);
        api.post<ConnexionRequest>("/login", request)
            .then(res => setData(res.data as ResponseApi))
            .catch(err => setError(err))
            .finally(() => setIsLoading(false));
        }
    }, [request]);

    return {data, isLoading, error };
}

export function useIsTokenValid(request: TokenValid | null | undefined){
    const [dataToken, setDataToken] = useState<ResponseApi>();
    const [isLoadingToken, setIsLoadingToken] = useState(false);
    const [errorToken, setErrorToken] = useState<any>(null);

    useEffect(() => {
        if (request) {
        setIsLoadingToken(true);
        apiSecure.post<ConnexionRequest>("/istokenvalid", request)
            .then(res => setDataToken(res.data as ResponseApi))
            .catch(err => setErrorToken(err))
            .finally(() => setIsLoadingToken(false));
        }
    }, [request]);

    return {dataToken, isLoadingToken, errorToken };
}